import { Trans } from '@lingui/react/macro'
import { BookingStep } from './BookingSteps/BookingStep'

export function BookingSkeleton() {
  return (
    <div className="h-auto flex flex-1 bg-blue-50">
      <div className="flex-1 max-w-xl pb-2 sm:pl-[10px] z-10">
        <div className="hidden md:block">
          <h1 className="font-bold text-3xl mt-8 mb-4">
            <Trans>Request a consultation</Trans>
          </h1>
        </div>
        <div className="flex flex-col gap-4">
          <BookingStep>
            <BookingStep.Title className="animate-pulse">
              <div className="w-1/2 h-8 bg-slate-200 rounded"></div>
            </BookingStep.Title>
            <BookingStep.Content className="animate-pulse flex flex-col gap-4">
              <div className="h-5 bg-slate-200 rounded"></div>
              <div className="h-5 bg-slate-200 rounded"></div>
            </BookingStep.Content>
          </BookingStep>
          <div className="animate-pulse w-1/2 h-8 bg-slate-200 rounded mx-4 sm:mx-0"></div>
          <div className="animate-pulse w-1/2 h-8 bg-slate-200 rounded mx-4 sm:mx-0"></div>
          <div className="animate-pulse w-1/2 h-8 bg-slate-200 rounded mx-4 sm:mx-0"></div>
        </div>
      </div>
      <div className="hidden sm:block flex-1">
        <div className="w-full h-full flex items-center justify-center bg-gray-400">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M9 18l-6 3V6l6-3m0 15l6 3m-6-3V3m6 18l6-3V3l-6 3m0 15V6" />
          </svg>
        </div>
      </div>
    </div>
  )
}
